import { Navigate } from 'react-router-dom';
import { usePMFeatures } from '../hooks/useFeatureFlag';
import ProjectManagement from '../components/ProjectManagement/ProjectManagement';

export default function ProjectsPage() {
  const hasAccess = usePMFeatures();

  // Redirect if user doesn't have access
  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }

  return <ProjectManagement />;
}